import * as React from 'react'

export const Toast = ({message, toastProps}) => {
   return (
      <div>
      {message}
      </div>
   )
}
